import Dropdown from "../Dropdown/Dropdown";
import {useCommonStore} from "../../hooks/useCommonStore";
import api from "../../utils/api";

const LangDropdown = () => {
  const {langOptions} = useCommonStore();
  const lang = localStorage.getItem("lang");

  const handleSelectLang = async(value) => {
    // await api.post('/v1/users/set-language', {language: value});
    localStorage.setItem('lang', value);
    window.location.reload();
  }

  if (langOptions && lang) {
    return (
      <Dropdown
        handleSelect={handleSelectLang}
        options={langOptions}
        defaultValue={lang}
      />
    );
  }
}

export default LangDropdown;